function isLoggedIn({ state, output }) {
  if (state.get('client.user')) {
    output.true()
  } else {
    output.false()
  }
}

isLoggedIn.outputs = ['true', 'false']
export default isLoggedIn



// WEBPACK FOOTER //
// ./src/modules/app/actions/isLoggedIn.js